import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Work_Details.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Work_Details({
  installDetails,
  setinstallDetails,
  isSubmitting,
  setIsSubmitting,
  handleSubmit,
}) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const locate = useLocation();
  const [workDetails, setWorkDetails] = useState();

  useEffect(() => {
    axios
      .get(`${apiUrl}workdetails/${installDetails._id}`)
      .then((res) => {
        console.log(res.data);
        setWorkDetails(res.data);
      })
      .catch((error) => {
        console.error("Error fetching work details:", error);
      });
  }, []);
  useEffect(() => {
    axios
      .post(apiUrl + "getdata-install", {
        leadId: locate.state?.leadId,
      })
      .then((res) => {
        setinstallDetails(res.data.message);
        console.log(res.data.message);
      });
  }, [locate.state?.leadId]);

  // Helper function to find photo by subtype
  const groupPhotosBySubtype = (photos) => {
    return (
      photos?.reduce((acc, photo) => {
        if (!acc[photo.subtype]) {
          acc[photo.subtype] = [];
        }
        acc[photo.subtype].push(photo);
        return acc;
      }, {}) || {}
    );
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };
  const planMonth =
    Number(installDetails?.installplanDetails?.installplanMonth) || 0;
  const planAmount =
    Number(installDetails?.installplanDetails?.installplanAmount) || 0;
  const staticIpCost =
    Number(installDetails?.installplanDetails?.installstaticIpCost) || 0;
  const installationCost =
    Number(installDetails?.installplanDetails?.installinstalationCost) || 0;
  const routerCost =
    Number(installDetails?.installplanDetails?.installrouterCost) || 0;
  const otherCost =
    Number(installDetails?.installplanDetails?.installothersCost) || 0;

  const totalPlanAmount = planMonth * planAmount;

  const baseAmount =
    totalPlanAmount + staticIpCost + installationCost + routerCost + otherCost;

  const gstAmount = baseAmount * 0.18;

  const orderValue = +(baseAmount + gstAmount).toFixed(2);

  const formattedOrderValue = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(orderValue);

  const plan = installDetails.installplanDetails || {};

  const installrouterCost = Number(plan.routerSellingCost) || 0;
  const installfiberCost = Number(plan.installfiberCost) || 0;
  const installfiberCableMeter = Number(plan.installfiberCableMeter) || 0;
  const installottPrice = Array.isArray(plan.installottPrice)
    ? Number(plan.installottPrice[0]) || 0
    : 0;
  const installothersCost = Number(plan.installothersCost) || 0;
  const OrderScore =
    baseAmount -
    installrouterCost -
    installfiberCableMeter * installfiberCost -
    installottPrice -
    installothersCost;

  console.log("OrderScore:", OrderScore);
  console.log(baseAmount, "baseamout");

  const formattedOrderScore = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(OrderScore);

  return (
    <div>
      <Container>
        <form>
          <div className="plan-details-container-border mt-3 text-center">
            <p style={{ fontSize: "13px" }} className="pt-2">
              <span className="text-primary">
                {installDetails?.installplanDetails?.installfiberCableMeter}
              </span>{" "}
              M,{" "}
              <span className="text-primary ">
                {installDetails?.installplanDetails?.installplanSpeed}
              </span>{" "}
              Mbps,{" "}
              <span className="text-primary">
                {" "}
                {installDetails?.installplanDetails?.installplanMonth}
              </span>
              Month @{" "}
              <span className="text-primary">
                Rs. {installDetails?.installplanDetails?.installplanAmount}
                /-
              </span>
            </p>
            <p style={{ fontSize: "13px" }}>
              Order Value @{" "}
              <span className="text-primary">Rs.{formattedOrderValue}/-</span>,
              OrderScore @{" "}
              <span className="text-primary">Rs.{formattedOrderScore}/-</span>
            </p>
          </div>

          <table className="table table-bordered mt-5">
            <thead className="table-th text-center">
              <tr>
                <th>Staff Name</th>
                <th>Bike Type</th>
                <th>KM Travel</th>
                <th>Cable Used</th>
                <th>Work Time</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(workDetails) && workDetails.length > 0 ? (
                workDetails.map((work) => (
                  <tr key={work._id} className="text-center">
                    <td>{work.staffName || "-"}</td>
                    <td>{work.bikeType || "-"}</td>
                    <td>
                      {work.kmTraveled !== null && work.kmTraveled !== undefined
                        ? `${work.kmTraveled} KM`
                        : "-"}
                    </td>
                    <td>
                      {work.cableUsed !== null && work.cableUsed !== undefined
                        ? work.cableUsed
                        : "-"}
                    </td>
                    <td>
                      {work.workTime !== null && work.workTime !== undefined ? (
                        <>
                          {Math.floor(work.workTime / 60) > 0 && (
                            <>
                              {Math.floor(work.workTime / 60)} Hour
                              {Math.floor(work.workTime / 60) !== 1 ? "s" : ""}
                              {work.workTime % 60 > 0 && " "}{" "}
                              {/* Add space only if minutes exist */}
                            </>
                          )}
                          {work.workTime % 60 > 0 && (
                            <>
                              {work.workTime % 60} Minute
                              {work.workTime % 60 !== 1 ? "s" : ""}
                            </>
                          )}
                          {Math.floor(work.workTime / 60) === 0 &&
                            work.workTime % 60 === 0 &&
                            "0 Minutes"}
                        </>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="mt-5 mb-5 work-photo-section">
            <label>
              <strong>Fiber Team Photos</strong>
            </label>

            {Object.entries(
              groupPhotosBySubtype(installDetails?.workDetails?.fiberTeamPhotos)
            ).map(([subtype, photos]) => (
              <div key={subtype} className="work-photo-group mt-3 mb-4">
                <h5>{subtype.charAt(0).toUpperCase() + subtype.slice(1)}</h5>
                <Row className="mt-3">
                  {photos.map((photo) => (
                    <Col className="text-center" key={photo._id} xs={6} md={3}>
                      <div className="ms-4">
                        <img
                          src={photo.image}
                          className="work-photo-img"
                          alt={`${subtype} by ${photo.staffName}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://placehold.co/150x130?text=No+Image";
                          }}
                        />
                        <p className="work-photo-meta mt-2">
                          By {photo.staffName}
                          <span className="ms-4">{formatDate(photo.date)}</span>
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            ))}

            <label className="mt-4">
              <strong>Network Team Photos</strong>
            </label>

            {Object.entries(
              groupPhotosBySubtype(
                installDetails?.workDetails?.networkTeamPhotos
              )
            ).map(([subtype, photos]) => (
              <div key={subtype} className="work-photo-group mt-3 mb-4">
                <h5>{subtype.charAt(0).toUpperCase() + subtype.slice(1)}</h5>
                <Row className="mt-3">
                  {photos.map((photo) => (
                    <Col className="text-center" key={photo._id} xs={6} md={3}>
                      <div className="ms-4">
                        <img
                          src={photo.image}
                          className="work-photo-img"
                          alt={`${subtype} by ${photo.staffName}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://placehold.co/150x130?text=No+Image";
                          }}
                        />
                        <p className="work-photo-meta mt-2">
                          By {photo.staffName}
                          <span className="ms-4">{formatDate(photo.date)}</span>
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            ))}
          </div>
        </form>
      </Container>
    </div>
  );
}
